export var SHOW_LOADER = "SHOW_LOADER";
export var HIDE_LOADER = "HIDE_LOADER";
export var SHOW_CONTINUE_LOADER = "SHOW_CONTINUE_LOADER";
export var SHOW_SUPPORT_MODAL = "SHOW_SUPPORT_MODAL";
export var SET_PAGE_ERROR = "SET_PAGE_ERROR";
export var SET_INLINE_ERROR = "SET_INLINE_ERROR";
export var CLEAR_INLINE_ERRORS = "CLEAR_INLINE_ERRORS";
export var SET_FORM_IS_SUBMITTING = "SET_FORM_IS_SUBMITTING";
export var SET_AUTO_REG_MODE = "SET_AUTO_REG_MODE";
export var SET_GLOBAL_LOADERS = "SET_GLOBAL_LOADERS";
